import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Toaster } from 'react-hot-toast';
import { Layout } from './components/layout/Layout';
import { LoginPage } from './pages/LoginPage';
import { Dashboard } from './pages/Dashboard';
import { PickingPage } from './pages/PickingPage';
import { ScannerPage } from './pages/ScannerPage';
import { BulkPickingPage } from './pages/WavePickingPage';
import { PackingPage } from './pages/PackingPage';
import { AdvancedFeaturesPage } from './pages/AdvancedFeaturesPage';
import { DiagnosticsPage } from './pages/DiagnosticsPage';
import { useAuthStore } from './stores/authStore';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuthStore();
  return user ? <>{children}</> : <Navigate to="/login" replace />;
};

export const App: React.FC = () => {
  return (
    <>
      <Router>
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="picking/:id" element={<PickingPage />} />
              <Route path="scanner" element={<ScannerPage />} />
              <Route path="bulk-picking" element={<BulkPickingPage />} />
              <Route path="bulk-picking/:id" element={<BulkPickingPage />} />
              <Route path="packing" element={<PackingPage />} />
              <Route path="packing/:id" element={<PackingPage />} />
              <Route path="advanced" element={<AdvancedFeaturesPage />} />
              <Route path="diagnostics" element={<DiagnosticsPage />} />
              <Route path="profile" element={
                <div className="p-4 text-center">
                  <h1 className="text-2xl font-bold text-gray-900">Profile</h1>
                  <p className="text-gray-600 mt-2">Coming soon...</p>
                </div>
              } />
            </Route>
            
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AnimatePresence>
      </Router>
      <Toaster position="top-right" />
    </>
  );
};

export default App;